module.exports = __webpack_public_path__ + "static/media/man_holding_key.f13e1bf8.svg";